import {
  notificationsDictionariesTranslation,
  NotificationsDictionariesTranslation,
} from '@/assets/locales/dictionaries/notifications/notifications.dictionaries.pl.ts';
import {
  rolesDictionariesTranslation,
  RolesDictionariesTranslation,
} from '@/assets/locales/dictionaries/roles/roles.dictionaries.pl.ts';
import {
  toStateOptionsDictionariesTranslation,
  ToStateOptionsDictionariesTranslation,
} from '@/assets/locales/dictionaries/toStateOptions/toStateOptions.dictionaries.pl.ts';
import {
  yesNoDictionariesTranslation,
  YesNoDictionariesTranslation,
} from '@/assets/locales/dictionaries/yesNo/yesNo.dictionaries.translation.pl.ts';

export type DictionariesTranslation = {
  notifications: NotificationsDictionariesTranslation;
  roles: RolesDictionariesTranslation;
  toStateOptions: ToStateOptionsDictionariesTranslation;
  yesNo: YesNoDictionariesTranslation;
};

export const dictionariesTranslation: DictionariesTranslation = {
  notifications: notificationsDictionariesTranslation,
  roles: rolesDictionariesTranslation,
  toStateOptions: toStateOptionsDictionariesTranslation,
  yesNo: yesNoDictionariesTranslation,
};
